import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";

type UserIdpGroupsListItemDescriptionCell = CellComponentProps;

const UserIdpGroupsListItemDescriptionCell = ({
  mappedGroup,
}: UserIdpGroupsListItemDescriptionCell) => {
  if (!mappedGroup?.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={mappedGroup.description}
      />
    </Box>
  );
};

export default UserIdpGroupsListItemDescriptionCell;
